import { cn } from '@/lib/utils'

interface StarRatingProps {
    rating: number
    /** The store's unit word after the number (`stars`); dropped when the store did not supply it. */
    label?: string
    className?: string
}

/**
 * Displays a teal star icon with a numeric rating.
 * Used on trip cards to show carrier ratings.
 */
export function StarRating({ rating, label, className }: StarRatingProps) {
    return (
        <span className={cn('flex items-center text-sm text-[#8c939c]', className)}>
            <svg
                className="mr-0.5 h-4 w-6 text-[#00bfd5]"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
            >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            <span>
                {rating.toFixed(1)}
                {label && (
                    <>
                        {' '}
                        <span className="sr-only md:not-sr-only">{label}</span>
                    </>
                )}
            </span>
        </span>
    )
}
